// React Hooks:
import React, { useState, useEffect } from "react";
// React-Router-Dom:
import { Outlet, useNavigate } from "react-router-dom";
// Redux Toolkit Hooks:
import { useAppDispatch, useAppSelector } from "../../app/hooks";
// Redux Toolkit Actions & State:
import { authentication, logoutAction } from "../authentication/authenticationSlice";
import { directoryItems } from "./home/directory/directory-items/directoryItemsSlice";
import { drawer } from "./home/drawer/drawerSlice";
// MUI Components:
import { Container, Grid, useTheme } from "@mui/material";
// Components:
import Header from "../global/header/Header";
import Sidebar from "../global/sidebar/Sidebar";
import ResponsiveSidebar from "../global/sidebar/responsive-sidebar/ResponsiveSidebar";
import Drawer from "./home/drawer/Drawer";
import ResponsiveDrawer from "./home/drawer/responsive-drawer/ResponsiveDrawer";
import LinkFileModal from "../global/link-file-modal/LinkFileModal";
import ResponsiveLinkFileModal from "../global/link-file-modal/responsive-link-file-modal/ResponsiveLinkFileModal";
import DeleteModal from "../global/delete-modal/DeleteModal";
import ResponsiveDeleteModal from "../global/delete-modal/responsive-delete-modal/ResponsiveDeleteModal";
import SubReportsModal from "../global/sub-reports-modal/SubReportsModal";
import ResponsiveSubReportsModal from "../global/sub-reports-modal/responsive-sub-reports-modal/ResponsiveSubReportsModal";
// MUI Styles:
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100vw",
    height: "100vh",
    backgroundColor: theme.palette.background.default,
    color: theme.palette.text.secondary,
    overflow: "hidden",
  },
}));

const Main = () => {
  const theme = useTheme();

  const classes = useStyles();

  const navigate = useNavigate();

  const dispatch = useAppDispatch();

  const { token, username, rule } = useAppSelector(authentication);

  const { openDrawer } = useAppSelector(drawer);

  const { touched } = useAppSelector(directoryItems);

  const [gridSize, setGridSize] = useState({
    sidebar: 1,
    main: 1,
    drawer: 0,
  });

  useEffect(() => {
    if (!token) {
      navigate("/login");
    }
  }, [navigate, token]);

  useEffect(() => {
    if (!username) {
      navigate("/login");
    }
  }, [navigate, username]);

  useEffect(() => {
    if (!rule) {
      navigate("/login");
    }
  }, [navigate, rule]);

  useEffect(() => {
    if (touched) {
      if (openDrawer) {
        setGridSize((last) => ({ ...last, sidebar: 0, drawer: 1 }));
      } else {
        setGridSize((last) => ({ ...last, sidebar: 0.8, drawer: 0.2 }));
      }
    } else {
      setGridSize((last) => ({ ...last, sidebar: 1, drawer: 0 }));
    }
  }, [touched, openDrawer]);

  // useEffect(() => {
  //   window.addEventListener('beforeunload', (event: any) => {
  //     localStorage.clear()
  //     dispatch(logoutAction())
  //   });
  //   return () => window.addEventListener('beforeunload', (event: any) => {
  //     localStorage.clear()
  //     dispatch(logoutAction())
  //   });
  // }, []);

  return (
    <Container
      maxWidth={false}
      sx={{ display: "flex", p: { xs: 0 }, direction: "rtl" }}
      className={classes.container}
    >
      <Grid
        container
        sx={{
          width: "100%",
          height: "100%",
          direction: "ltr",
          position: "relative",
        }}
      >
        <ResponsiveSidebar />
        <ResponsiveDrawer />

        <LinkFileModal />
        <ResponsiveLinkFileModal />

        <DeleteModal />
        <ResponsiveDeleteModal />

        <SubReportsModal />
        <ResponsiveSubReportsModal />

        <Grid item xs={12} sx={{ width: "100%", height: "50px", zIndex: 3 }}>
          <Header />
        </Grid>

        <Grid
          item
          container
          sx={{
            width: "100%",
            height: "calc(100% - 50px)",
            position: "relative",
          }}
          id="modalContainer"
        >
          <Grid
            item
            xl={2 * gridSize.sidebar}
            lg={2.5 * gridSize.sidebar}
            md={3 * gridSize.sidebar}
            sm={3.5 * gridSize.sidebar}
            xs={0}
            sx={{
              width: "100%",
              height: "100%",
              transition: "all 0.4s",
              flexBasis: "0%",
              maxWidth: "0%",
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
            }}
          >
            <Sidebar />
          </Grid>

          <Grid
            item
            xl={10 * gridSize.main}
            lg={9.5 * gridSize.main}
            md={9 * gridSize.main}
            sm={8.5 * gridSize.main}
            xs={12}
            sx={{
              width: "100%",
              height: "100%",
              p: "24px 24px 16px 24px",
              transition: "all 0.4s",
            }}
          >
            <Outlet />
          </Grid>

          <Grid
            item
            xl={2 * gridSize.drawer}
            lg={2.5 * gridSize.drawer}
            md={3 * gridSize.drawer}
            sm={3.5 * gridSize.drawer}
            xs={0}
            sx={{
              width: "100%",
              height: "100%",
              transition: "all 0.4s",
              flexBasis: "0%",
              maxWidth: "0%",
              [theme.breakpoints.down("sm")]: {
                display: "none",
              },
            }}
          >
            <Drawer />
          </Grid>
        </Grid>
      </Grid>
    </Container>
  );
};

export default Main;
